import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Employment } from 'server/shared/models/employment';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-employment-organisation-heading',
  templateUrl: './employment-organisation-heading.component.html',
  styleUrls: ['./employment-organisation-heading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmploymentOrganisationHeadingComponent implements OnInit {
  employment$ = new BehaviorSubject<Employment | undefined>(undefined);

  @Input() set employment(value: Employment | undefined) {
    this.employment$.next(value);
  }
  get employment() {
    return this.employment$.value;
  }

  constructor() {}

  ngOnInit(): void {}
}
